/* eslint-disable */

// Classe abstrata que define o contrato de um provedor de mapa.
//
// As implementações concretas (HereMapAdapter, LeafletMapAdapter) devem
// sobrescrever todos os métodos. A camada de UI (layouts/mapa/mapa.js) e a
// store (stores/mapa.js) só conversam com esta interface — nunca com o SDK
// específico (H.* ou L.*) — o que permite trocar de provedor pelo flag em
// config/mapProvider.js sem mexer no resto do app.
//
// Os marcadores são gerenciados por uma CHAVE string (ex: id do pedido,
// 'origem', 'entregador_<id>'), então nenhuma parte do app precisa saber o
// tipo nativo do marcador. O ícone é sempre uma string SVG.

export default class MapAdapter {
  // ---- ciclo de vida ----

  // Cria e anexa o mapa no container.
  // opts: { container, center:{lat,lng}, zoom, onViewChange(zoom,lat,lng) }
  init(opts) {
    throw new Error("MapAdapter.init() não implementado");
  }

  // Reaplica o tamanho do mapa (chamado quando o container muda de tamanho).
  resize() {
    throw new Error("MapAdapter.resize() não implementado");
  }

  // Centraliza o mapa em (lat,lng) com zoom opcional.
  setView(lat, lng, zoom) {
    throw new Error("MapAdapter.setView() não implementado");
  }

  // Libera recursos (listeners, timers). NÃO precisa destruir o mapa em si.
  destroy() {}

  // Mapa nativo subjacente (escape hatch; evite usar fora do adapter).
  get raw() {
    return null;
  }

  // ---- marcadores (registro por chave) ----

  // Cria e adiciona um marcador identificado por `key`.
  // opts: { zIndex, anchor:[x,y], size:[w,h], onTap() }
  addMarker(key, lat, lng, svg, opts) {
    throw new Error("MapAdapter.addMarker() não implementado");
  }

  hasMarker(key) {
    throw new Error("MapAdapter.hasMarker() não implementado");
  }

  // Retorna { lat, lng } ou null.
  getMarkerPosition(key) {
    throw new Error("MapAdapter.getMarkerPosition() não implementado");
  }

  setMarkerPosition(key, lat, lng) {
    throw new Error("MapAdapter.setMarkerPosition() não implementado");
  }

  setMarkerIcon(key, svg, opts) {
    throw new Error("MapAdapter.setMarkerIcon() não implementado");
  }

  removeMarker(key) {
    throw new Error("MapAdapter.removeMarker() não implementado");
  }

  // Lista todas as chaves de marcadores atualmente no mapa.
  getMarkerKeys() {
    throw new Error("MapAdapter.getMarkerKeys() não implementado");
  }

  // Remove todos os marcadores cuja chave satisfaz predicate(key) === true.
  removeMarkersWhere(predicate) {
    this.getMarkerKeys()
      .filter((key) => predicate(key))
      .forEach((key) => this.removeMarker(key));
  }

  // ---- rotas ----

  // Calcula e desenha a rota. async.
  // params: { origin:"lat,lng", destination:"lat,lng", via:["lat,lng", ...] }
  showRoute(params) {
    throw new Error("MapAdapter.showRoute() não implementado");
  }

  // Remove a rota desenhada.
  clearRoutes() {
    throw new Error("MapAdapter.clearRoutes() não implementado");
  }

  // ---- geo ----

  // Distância em metros entre dois pontos {lat,lng}.
  distanceMeters(a, b) {
    throw new Error("MapAdapter.distanceMeters() não implementado");
  }
}
